import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'

interface Props {
  position?: string
}

export function ShiftPositionView(props: Props) {
  const styles = useStyles()

  return (
    <Text style={styles.container} numberOfLines={2}>
      {props.position && props.position.length > 0
        ? props.position
        : t('anyPosition')}
    </Text>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    fontSize: 13,
    color: theme.colors?.black,
  },
}))
